import { motion } from "framer-motion";
import { commonOpacity } from "../../animateConstant";
import { getFixedStyle } from "../../hook/useDeviceType";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import { Button } from "semantic-ui-react";
import ButtonTab from "../../components/TabComponent/ButtonTab";
import { useEffect, useMemo, useState } from "react";
import RewardCard from "./components/RewardCard";
import DateSelect from "../../components/TimePicker/DateSelect";
import NotFound from "../../components/ProgressBlock/NotFound";
import LoadingBlock from "../../components/Loading/LoadingBlock";
import DetailWrapper from "../../components/detailWrapper";
import TimePicker from "../../components/TimePicker/TimePicker";
import { formatTime, getToday } from "../../utils/getDay";
import { useTranslation } from "react-i18next";
import { getGiftList, getUsedGiftList } from "../../api/getApi";
import UsedRewardCard from "./components/usedRewardCard";
import LoadingReward from "../../components/Loading/LoadingReward";
import { useSelector } from "react-redux";

const SimpleRewards = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`reward.${key}`);

  const TAB = [
    { label: i18n("unUse"), value: "unUse" },
    { label: i18n("used"), value: "used" },
  ];

  const [tab, setTab] = useState(TAB[0].value);
  const [datePicker, setDatePicker] = useState({
    str_date: getToday(),
    end_date: getToday(),
  });
  const globalTrigger = useSelector((state) => state.isGlobalTrigger);
  const [giftList, setGiftList] = useState([
    // {
    //   uid: 66653,
    //   giftName: "Điểm danh mỗi ngày 20.000", //禮包名稱
    //   useDate: "2023-10-23 16:43:54", //使用日期
    //   useGameName: "evoSingle", //遊戲名稱
    //   playBet: "290400/0", //投注量/解凍投注
    //   isuse: 1, //狀態顯示在前端,0:可轉點,1:鎖定中,else:已凍結
    //   open: 1, //在遊戲轉點時卻認可用的禮包1是可用,0是不能用
    // },
    // {
    //   uid: 66654,
    //   giftName: "Chuyển điểm tặng 5%(轉入送5%)",
    //   useDate: "2023-10-23 16:52:06",
    //   useGameName: "evoSingle",
    //   playBet: "0/3875500",
    //   isuse: 1,
    //   open: 0,
    // },
  ]);
  const [apiCalling, setApiCalling] = useState(false);

  useEffect(() => {
    setApiCalling(true);
    getUsedGiftList({
      str_date: datePicker.str_date,
      end_date: datePicker.end_date,
    })
      .then((data) => {
        setGiftList(data.data);
      })
      .catch((err) => {})
      .finally(() => {
        setApiCalling(false);
      });

    setTimeout(() => {
      setApiCalling(false);
    }, 2000);
  }, [tab, datePicker, globalTrigger]);

  const tabGiftList = useMemo(() => {
    return giftList?.filter((item) => {
      if (tab === "unUse") {
        return item.isuse == 0;
      } else {
        return item.isuse == 1;
      }
    });
  }, [tab, giftList]);

  return (
    <DetailWrapper>
      <CloseDetailPage title={i18n("myReward")} />
      <section className="mb-[20px]">
        <ButtonTab TABS={TAB} setTab={setTab} tab={tab} />
      </section>
      {/* <p className="text-2xl font-medium text-transaction-text tracking-tighter">
        {i18n("availableBonuses")}{" "}
      </p> */}
      <section>
        <DateSelect setDatePicker={setDatePicker} />
      </section>
      <section>
        <LoadingReward commonLoading={apiCalling}>
          <section>
            {tabGiftList?.length !== 0 ? (
              tabGiftList?.map((item, index) => {
                return (
                  <UsedRewardCard
                    bonusName={item.giftName}
                    usedTime={item.useDate}
                    usedGame={item.useGameName}
                    playBet={item.playBet}
                    isuse={item.isuse}
                    itemProps={item}
                  />
                );
              })
            ) : (
              <NotFound />
            )}
          </section>
        </LoadingReward>
      </section>
    </DetailWrapper>
  );
};

export default SimpleRewards;
